__turbopack_context__.v({
  "asset": "MeasureFeatureMedia-module__Vg3Cea__asset",
  "back": "MeasureFeatureMedia-module__Vg3Cea__back",
  "canvas": "MeasureFeatureMedia-module__Vg3Cea__canvas",
  "canvasOut": "MeasureFeatureMedia-module__Vg3Cea__canvasOut",
  "fadeIn": "MeasureFeatureMedia-module__Vg3Cea__fadeIn",
  "front": "MeasureFeatureMedia-module__Vg3Cea__front",
  "slot": "MeasureFeatureMedia-module__Vg3Cea__slot",
  "stage": "MeasureFeatureMedia-module__Vg3Cea__stage",
  "stageFadeIn": "MeasureFeatureMedia-module__Vg3Cea__stageFadeIn",
  "video": "MeasureFeatureMedia-module__Vg3Cea__video",
  "videoFrame": "MeasureFeatureMedia-module__Vg3Cea__videoFrame",
  "videoOn": "MeasureFeatureMedia-module__Vg3Cea__videoOn",
});
